module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8291ddf989380c548d5888b54fce3413.png";